import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import styled from "styled-components";
import { COLORS } from "../../styles/colors";

export interface WxIconProps {
  icon: IconProp;
  active?: boolean;
  light?: boolean;
  onClick?: () => void;
}

const WxIcon = ({
  icon,
  active = false,
  light = false,
  onClick = () => {},
}: WxIconProps) => (
  <Span data-active={active} light={light} onClick={onClick}>
    <FontAwesomeIcon icon={icon} />
  </Span>
);

const Span = styled.span<{ light?: boolean }>`
  color: ${(props) => (props.light ? COLORS.white : COLORS.black)};
  min-width: 26px;
  min-height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  font-size: 0.75rem;
  cursor: pointer;

  &[data-active="true"]::after {
    content: "";
    width: 100%;
    height: 2px;
    background-color: ${COLORS.red};
    position: absolute;
    bottom: 0;
  }
`;

export default WxIcon;
